module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-437.0f406d2.woff2";